.controlMitigationTab {
    margin-top: 20px;
}

.averageWeightedEffectiveness {
    display: flex;
    flex-direction: column;
}

.average {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
